var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyView',{attrs:{"name":_vm.text.name,"description":_vm.text.description},scopedSlots:_vm._u([{key:"icon",fn:function(){return [(_vm.callUser)?_c('NcLoadingIcon'):_c('NcIconSvgWrapper',{attrs:{"svg":_vm.IconTalk}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }